import { Pipe, PipeTransform } from '@angular/core';
import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';
import { IShopPaymentMethod } from '@x/ecommerce/shop-client';

@Pipe({
  name: 'iconPaymentMethod',
})
export class IconPaymentMethodPipe implements PipeTransform {
  transform(method: IShopPaymentMethod): IconProp {
    switch (method.provider) {
      case 'peach-eft':
        return 'money-bill-transfer';
      case 'icare-payment':
        return 'gift-card';
      default:
        return 'saved-card' as IconName;
    }
  }
}
